import { AppScheme } from "@fe_utils/fe_sdk_base";
import _ from "lodash";

export const appInfoPhoneFirstList = [
  {
    appName: "来音制谱",
    scheme: AppScheme.Laiyineditscore,
    appIcon: "https://static.quthing.com/fe/img/base/lyzp_icon.png",
    appIntro: "超简单的数字乐谱创作编辑工具",
    rate: 4.9,
    rateNumbers: "1w+个评分",
    awards: [
      {
        name: "APP安利",
        device: "OPPO",
        gold: false,
      },
    ],
    comments: [
      "“非常强大！扫描一下原谱就可以五线谱和简谱互转，还能一键改调” ——中国特色社会主义中国梦",
      "“东西很全！乐谱可以选择钢琴、吉他、小提琴、古筝等各种各样的，而且还可以自定义，各种各样的音符、记号、力度、表情术语……甚至还有弱起等。值得入手。” ——HuZeHua",
    ],
  },
  {
    appName: "懂音律",
    scheme: AppScheme.Rhythm,
    appIcon: "https://cdn.quthing.com/laiyin_dongyinlv_logo_icon.webp",
    appIntro: "全乐器数字乐谱共享与学习平台",
    rate: 4.9,
    rateNumbers: "8w+个评分",
    awards: [
      {
        name: "极光奖",
        device: "VIVO",
        gold: true,
      },
      {
        name: "专题推荐",
        device: "华为",
        gold: false,
      },
      {
        name: "APP安利",
        device: "OPPO",
        gold: false,
      },
    ],
    comments: [
      "“这个软件是来扶贫的吧！ 没有花里胡哨的广告和充值界面 还有乐理知识可以看 谱子完全免费！” ——花花花花花好",
      "“全部免费🆓，有30多个乐器，建议下载，有陪练，像老师一样，还有自动给你标注是什么音” ——辰辰🦆",
    ],
  },
  {
    appName: "来音智能陪练",
    scheme: AppScheme.Partnertrainingai,
    appIcon: "https://cdn.quthing.com/laiyin_ai_logo_icon.webp",
    appIntro: "激发孩子练琴兴趣，解放家长时间",
    rate: 4.7,
    rateNumbers: "1w+个评分",
    awards: [
      {
        name: "首页推荐",
        device: "OPPO·华为",
        gold: false,
      },
    ],
    comments: [
      "“孩子今年考十级！难度高了！已经跟不上她的节奏，小红书上无意看到这个软件，用了一下，孩子瞬间开心了，识别非常准确流畅，终于找到好用的Ai陪练！” ——方大希",
      "“辅导孩子练琴，来音是个很不错的工具，激发孩子的兴趣，帮助家长与孩子互动，促进学习进步。点赞👍” ——奋进的小孩",
    ],
  },
  {
    appName: "来音练琴",
    scheme: AppScheme.Partnertrainingstudent,
    appIcon: "https://cdn.quthing.com/partner_appicon.png",
    appIntro: "真人老师1v1视频上课，一课一付",
    rate: 4.8,
    rateNumbers: "1000+个评分",
    awards: [
      {
        name: "新锐榜单",
        device: "荣耀",
        gold: false,
      },
    ],
    comments: [
      "“来音练琴约课很方便灵活，想约几次约几次，随时取消。老师也很认真负责，讲解到位，有示范。孩子进步很大！”——Lucky-lucky123",
      "“好用，而且不用担心平台跑路，因为是一课一付”——小瑜干",
    ],
  },
  {
    appName: "来音节拍器",
    scheme: AppScheme.Metronome,
    appIcon: "https://cdn.quthing.com/laiyin_jiepaiqi_logo_icon.webp",
    appIntro: "节奏准确，用不坏的专业节拍器",
    rate: 4.7,
    rateNumbers: "20w+个评分",
    awards: [
      {
        name: "首页推荐",
        device: "OPPO·荣耀",
        gold: false,
      },
    ],
    comments: [
      "“挺不错的节拍器。里面的功能很详细，很多，主要是节奏类型可以自己选很实用” ——想不到lllp",
      "“节奏准确，声音清晰悦耳，速度调节随心所欲，比机械的节拍器好用！” ——云雾僧",
    ],
  },
  {
    appName: "来音调音器",
    scheme: AppScheme.Laiyintuner,
    appIcon: "https://static.quthing.com/fe/img/base/laiyin_tuner_logo.png",
    appIntro: "智能自动调音，让调音又快又准",
    rate: 4.8,
    rateNumbers: "12w+个评分",
    awards: [
      {
        name: "首页推荐",
        device: "OPPO·荣耀",
        gold: false,
      },
    ],
    comments: [
      "“非常方便啊，很多乐器都能调音，一个软件就都搞定了” ——gu 如",
      "“随身携带的调音器，好用方便，还准确” ——康师傅喝小茉莉",
    ],
  },
  {
    appName: "来音乐理手册",
    scheme: AppScheme.Laiyinmusictheory,
    appIcon: "https://cdn.quthing.com/laiyin_yuelishouce_logo_icon.webp",
    appIntro: "乐理视唱一学就会",
    rate: 4.7,
    rateNumbers: "5000+个评分",
    awards: [
      {
        name: "新锐榜单",
        device: "荣耀",
        gold: false,
      },
    ],
    comments: [
      "“三小门都知识很齐全而且题库很丰富，求求更多人发现这个宝藏软件，让他越做越好” ——生菜(｀∀´)Ψ乐滋滋",
      "“很划算，而且里面的题都很好，都可以做，由简入难都可以，里面还有教程啊什么好多知识点都有，还有各大音乐学院的考试题目。” ——Iam****",
    ],
  },
  {
    appName: "来音伴奏",
    scheme: AppScheme.Laiyinaccompany,
    appIcon: "https://cdn.quthing.com/app_icon/laiyin_accompany_logo_icon.webp",//accompaniment
    appIntro: "专业音乐伴奏智能提取和编辑工具",
    rate: 4.9,
    rateNumbers: "1000+个评分",
    awards: [],
    comments: [
      "“操作简单方便，一目了然。可以将伴奏分轨，剪辑需要的部分，并且可以复制粘贴重复需要的片段。还可以随心所欲的升高降低伴奏的音调。加入混响。非常好用。推荐👍”——Kixixii",
      "“朋友推荐下载的，使用真的超级简单，我导入我和朋友在KTV录制的一段音频，清晰的分离出了钢琴贝斯吉他架子鼓，不仅歌声去除的很好，聊天的声音也都出去了，太惊艳了！” ——又见晴天",
    ],
  }
];
export const appInfoDesktopFirstList = [
  ...appInfoPhoneFirstList,
  {
    blank: true,
    appName: "",
    scheme: "",
    appIcon: "",
    appIntro: "",
    rate: 0,
    rateNumbers: "",
    awards: [],
    comments: [],
  },
];
export const appInfoPhoneSecondList = [
  {
    appName: "来音钢琴",
    scheme: AppScheme.Xihangpiano,
    appIcon: "https://cdn.quthing.com/laiyin_piano_logo_icon.webp",
    appIntro: "专为钢琴爱好者打造的一站式学习软件",
    rate: 4.8,
    rateNumbers: "17w+个评分",
    awards: [
      {
        name: "首页推荐",
        device: "OPPO·VIVO·华为·荣耀",
        gold: false,
      },
    ],
    comments: [
      "“整体来说非常不错，弹奏体验非常棒。我是零基础，接触来音钢琴后，让我掌握了很多的钢琴基础知识。功能非常全面，有智能陪练，努力争取学会弹钢琴” ——susan～",
      "“钢琴音质非常好，像真的弹钢琴一样有指导，而且里面你想弹什么歌曲什么都有” ——不骄不躁～",
    ],
  },
  {
    appName: "来音古筝",
    scheme: AppScheme.Flutterguzheng,
    appIcon: "https://cdn.quthing.com/laiyin_guzheng_logo_icon.webp",
    appIntro: "学习古筝的必备软件，用手机就能弹古筝",
    rate: 4.8,
    rateNumbers: "4w+个评分",
    awards: [
      {
        name: "首页推荐",
        device: "VIVO",
        gold: false,
      },
    ],
    comments: [
      "“第一次弹，好上手，才下几天就学会了年轮、兰亭序等歌，新手入门必备” ——神金的",
      "“感觉很好用啊，并且还很耐心，有很多模式指导你弹古筝，而且没有广告大家可以入手耶不用充很多钱” ——小*******",
    ],
  },
  {
    appName: "来音吉他",
    scheme: AppScheme.Laiyinguitar,
    appIcon: "https://cdn.quthing.com/laiyin_jita_logo_icon.webp",
    appIntro: "全面专业的吉他学习软件",
    rate: 4.9,
    rateNumbers: "4w+个评分",
    awards: [
      {
        name: "先锋共建",
        device: "荣耀",
        gold: true,
      },
    ],
    comments: [
      "“非常好，对新手很友好，教学很清楚，讲的每个教程都可以听得懂” ——果和冻",
      "“好用，本来就是打算给琴调调音，意外收获了！还能手把手教学，对初学小白很友好🥹🥹🥹” ——唐.白居易～",
    ],
  },
  {
    appName: "开嗓练声",
    scheme: AppScheme.Vocalmusic,
    appIcon: "https://cdn.quthing.com/laiyin_kaisangliansheng_logo_icon.webp",
    appIntro: "学唱歌、练声乐，一个 APP 全搞定",
    rate: 4.8,
    rateNumbers: "1w+个评分",
    awards: [
      {
        name: "首页推荐",
        device: "华为·荣耀",
        gold: false,
      },
    ],
    comments: [
      "“音乐生的福音，功能很丰富有音阶练习，声乐课程教学等，而且能够自定义音阶，大大提升了练声效率。新增加的视唱练耳，音调仪功能也非常好使” ——璇*******",
      "“很好用的一款唱歌，音准练习声乐教学软件” ——老王OKk",
    ],
  },
  {
    appName: "来音尤克里里",
    scheme: AppScheme.Laiyinukulele,
    appIcon: "https://cdn.quthing.com/laiyin_ukelili_logo_icon.webp",
    appIntro: "学习尤克里里的必备软件",
    rate: 4.7,
    rateNumbers: "1000+个评分",
    awards: [
      {
        name: "新锐榜单",
        device: "荣耀",
        gold: false,
      },
    ],
    comments: [
      "“里面有自动的节奏型，按下和弦还可以唱歌！小白也能弹出好听的伴奏，非常方便在外面唱歌没有伴奏的时候，随时随地打开来音尤克里里就可以尽情的嗨唱啦！也能帮助我学习尤克里里～真的非常好用！” ——001x战警",
      "“一直在找能把调音、查和弦这些功能做到一起的app，终于找到了！还能自弹自唱，推荐～” ——Orange_skyline",
    ],
  },
  {
    appName: "来音小提琴",
    scheme: AppScheme.Laiyinviolin,
    appIcon: "https://cdn.quthing.com/laiyin_xiaotiqin_logo_icon.webp",
    appIntro: "小提琴调音器、节拍器",
    rate: 4.7,
    rateNumbers: "1000+个评分",
    awards: [
      {
        name: "新锐榜单",
        device: "荣耀",
        gold: false,
      },
    ],
    comments: [
      "“有专门的小提琴节拍器、调音器。还有丰富的练习曲库，真是太方便啦～家人们，快下起来，不可错过的好用软件👍🏻👍🏻👍🏻” ——阿灰10097",
    ],
  },
  {
    appName: "来音架子鼓",
    scheme: "",
    appIcon: "https://static.quthing.com/fe/img/base/laiyin_jiazigu_logo.png",
    appIntro: "高保真模拟与创作分享于一体的App",
    rate: 4.7,
    rateNumbers: "3000+个评分",
    awards: [],
    comments: [
      "“特别好，有教程，新手爱好者都可以用” ——佳丽6666",
      "“值得推荐的架子鼓游戏 ，可以和小孩一起学习，一起玩架子鼓，提升兴趣”——刚下载的不知道",
    ],
  },

];
export const appInfoDesktopSecondList = [
  ...appInfoPhoneSecondList,
  {
    blank: true,
    appName: "",
    scheme: "",
    appIcon: "",
    appIntro: "",
    rate: 0,
    rateNumbers: "",
    awards: [],
    comments: [],
  },
];
export const appInfoPhoneList = _.map(appInfoPhoneFirstList, (item, index) => {
  return [item, appInfoPhoneSecondList[index]];
});
export const coreTeamList = [
  {
    url: require("../../components/images/CEO_card_bg.png"),
    name: "李帅",
    position: "CEO",
    contentList: [
      "钢琴十级，琴童家长",
      "毕业于华中科技大学计算机系",
      "中国早期移动端技术专家",
      "曾任美团iOS技术团队负责人",
      "曾任美团技术委员会成员",
      "连续成功创业者",
      "连续6年获聘“北京市创业导师”",
    ],
  },
  {
    url: require("../../components/images/CTO_card_bg.png"),
    name: "周志华",
    position: "CTO",
    contentList: [
      "全面负责技术创新研究",
      "毕业于东北师大软件工程系",
      "连续成功创业者",
      "全栈技术大神",
      "曾为人人游戏搭建承载千万级用户技术框架",
    ],
  },
  {
    url: require("../../components/images/CPO_card_bg.png"),
    name: "马钊",
    position: "CPO",
    contentList: [
      "全面负责公司产品及移动端技术方向把控",
      "毕业于吉林大学软件工程系",
      "曾任美团产品技术委员会常委",
      "曾任美团金融业务负责人",
    ],
  },
];
